import csHelper from "@/utils/product/content-structure-helpers";
import { ContentStructureSection } from "@/models/content-structure.model";
import { ProductSection } from "@/models/product-section.model";
import { AssetLocation } from "@/models/assets.model";
import { truncateString } from "@/utils/text-helpers";
import { PathToDisplay } from "@/models/product-section.model";

export const getPathToSection = (
  rootSection: ContentStructureSection,
  parentSectionId: number
): string[] => {
  const base = csHelper.getPathToSection(rootSection, parentSectionId) || [];
  const parent = csHelper.findDescendentSection(rootSection, parentSectionId);
  if (parent) {
    return parent.isRoot ? base : base.concat(parent.name);
  }
  return [];
};
export const convertPathToString = (
  pathArray: string[],
  currentContentName: string,
  productName: string
): string => {
  if (pathArray.length) {
    const sectionsPath = pathArray.join("/");
    return `${productName}/${sectionsPath}/${currentContentName}`;
  }
  return `${productName}/${currentContentName}`;
};

export const getPossiblePaths = (
  sections: ProductSection[],
  rootSection: ContentStructureSection
): AssetLocation[][] => {
  return sections
    .filter(
      // remove root section
      (section: ProductSection): boolean => {
        return !!section.parent_section_id;
      }
    )
    .map((section: ProductSection): AssetLocation[] => {
      // create path for each section
      const path = csHelper.getPathToSectionWithIds(rootSection, section.id);
      if (path) {
        path.push({
          name: section.name,
          id: section.id,
          iconId: section.type.icon_id,
          externalId: section.client_external_id
            ? section.client_external_id
            : ""
        });
      }
      return path;
    });
};
export const getPathsForDisplay = (
  paths: AssetLocation[][],
  productName: string
): PathToDisplay[] => {
  return paths.map((path: AssetLocation[]) => {
    const pathString = path.map((pathItem: AssetLocation) => {
      return truncateString(pathItem.name, 45);
    });
    return {
      lastChildSectionId: path[path.length - 1].id,
      pathString: `${productName}/${pathString.join("/")}`
    };
  });
};
export const getPathsForDisplayWithoutDuplicates = (
  paths: AssetLocation[][],
  productName: string
): PathToDisplay[] => {
  const pathsForDisplay = getPathsForDisplay(paths, productName);
  return pathsForDisplay.reduce(
    (acc: PathToDisplay[], item: PathToDisplay): PathToDisplay[] => {
      const prevItem = acc.find((prevItem: PathToDisplay): boolean => {
        return prevItem.pathString === item.pathString;
      });
      if (!prevItem) {
        acc.push(item);
      }
      return acc;
    },
    []
  );
};
export const getSortedPathsForDisplay = (
  paths: AssetLocation[][],
  productName: string
): PathToDisplay[] => {
  // sort in alphabetical order
  const pathsForDisplay = getPathsForDisplayWithoutDuplicates(
    paths,
    productName
  );
  return pathsForDisplay.sort((a: PathToDisplay, b: PathToDisplay) => {
    return ("" + a.pathString).localeCompare(b.pathString);
  });
};
